

































































































































































































































































































































































































































import Vue from 'vue'
import Swiper from 'swiper'
import Cookies from 'js-cookie'
import TutorialIndicatorDot from '@/components/play/tutorial/TutorialIndicatorDot.vue'
import Trivia from '@/components/Trivia.vue'
import TutorialDontShowAgain from '@/components/play/tutorial/TutorialDontShowAgain.vue'
import SampleSound from '@/components/SampleSound.vue'
import settings from '@/settings'

interface State {
  swiper: Swiper | null;
  currentSlide: number; // 表示中のスライド
  isPlayingTrivia: boolean; // トリビア表示中
  dontShowAgain: boolean; // 次回から表示しない
}

export default Vue.extend({
  name: 'Tutorial',

  components: {
    'tutorial-indicator-dot': TutorialIndicatorDot,
    trivia: Trivia,
    'tutorial-dont-show-again': TutorialDontShowAgain,
    'sample-sound': SampleSound,
  },

  data (): State {
    return {
      swiper: null,
      currentSlide: 0,
      isPlayingTrivia: false,
      dontShowAgain: Boolean(Number(Cookies.get(settings.cookieName.isTutorialSkip))),
    }
  },

  mounted () {
    if (!this.swiper) {
      this.swiper = new Swiper(this.$refs['swiper-container'])
    }

    this.currentSlide = this.swiper.activeIndex

    this.swiper.on('slideChange', (swiper: Swiper) => {
      this.currentSlide = swiper.activeIndex
    })
  },

  computed: {
    isFirstSlide (): boolean {
      return this.currentSlide === 0
    },

    isLastSlide (): boolean {
      return this.currentSlide >= 7
    },
  },

  methods: {
    /**
     * 次のスライドへ
     */
    slideNext () {
      if (this.swiper) {
        this.swiper.slideNext()
      }
    },

    /**
     * 前のスライドへ
     */
    slidePrev () {
      if (this.swiper) {
        this.swiper.slidePrev()
      }
    },

    /**
     * 指定のスライドへ移動
     * @param index
     */
    slideTo (index: number) {
      if (this.swiper) {
        this.swiper.slideTo(index)
      }
    },

    /**
     * 次回から表示しないを切り替え
     */
    toggleDontShowAgain () {
      this.dontShowAgain = !this.dontShowAgain
    },

    /**
     * 閉じる
     */
    dismiss () {
      this.$emit('dismiss')
    },

    /**
     * 豆知識を閉じる
     */
    dismissTrivia () {
      console.log('dismissTrivia')
      this.isPlayingTrivia = false
    },

    /**
     * cookieに保存
     */
    saveCookie () {
      // 有効期限を更新するために、一度削除
      Cookies.remove(settings.cookieName.isTutorialSkip)

      // 削除後に保存（有効期限を更新する）
      Cookies.set(settings.cookieName.isTutorialSkip, '1', {
        expires: 30,
      })
    },

    /**
     * cookieを削除
     */
    removeCookie () {
      Cookies.remove(settings.cookieName.isTutorialSkip)
    },
  },

  watch: {
    dontShowAgain (val: boolean) {
      if (val) {
        // skipの情報をcookieに保存
        this.saveCookie()
      } else {
        this.removeCookie()
      }
    },
  },
})
